import { gql } from '@apollo/client';
import type { Coordinate, UUID } from '@cobliteam/common-types';
import graphQLRequester from '../../request/GraphQLRequester';
import type { GraphQLRestDataSourceError } from '../../request/Types';
import type { CoordinateAPI } from './definitions';

export class GraphQLFaceImageGeolocationRequester {
  private queryGetFaceImageGeolocation = gql`
    query getFaceImageGeolocation($imageId: ID!) {
      faceImageGeolocation(imageId: $imageId) {
        latitude
        longitude
      }
    }
  `;

  public getFaceImageGeolocation = (imageId: UUID): Promise<Coordinate | null> =>
    graphQLRequester
      .query<{
        faceImageGeolocation: CoordinateAPI | null;
        errors: Array<GraphQLRestDataSourceError>;
      }>({
        query: this.queryGetFaceImageGeolocation,
        variables: { imageId },
      })
      .then((result) => {
        if (result.errors !== undefined) {
          throw result.errors[0];
        }

        return result.faceImageGeolocation;
      });
}

export default GraphQLFaceImageGeolocationRequester;
